/* SWSkinn analytics — one event contract, vendor-neutral.
   Pushes to window.dataLayer (GTM / GA4). Add a GTM container in build.py <head> to activate.
   Event names (keep stable — dashboards depend on them):
   analysis_start, camera_open, camera_permission_denied, camera_complete, camera_failure,
   image_rejected, questionnaire_step, questionnaire_complete, safety_escalation, results_view,
   whatsapp_optin, whatsapp_handoff, whatsapp_handoff_failed, product_view, shopify_click,
   analysis_cta, shop_cta, reassessment_start
   Cart / checkout / purchase / bundle_purchase / reorder are measured on Shopify
   (utm_source=swskinn.com + sw_session in cart attributes). */
(function () {
  window.dataLayer = window.dataLayer || [];
  var sid = null;
  try { sid = sessionStorage.getItem('sw_sid'); } catch (e) {}
  if (!sid) {
    sid = 'sw-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
    try { sessionStorage.setItem('sw_sid', sid); } catch (e) {}
  }
  function track(event, props) {
    var payload = Object.assign({ event: event, sw_session: sid, page: location.pathname, ts: new Date().toISOString() }, props || {});
    window.dataLayer.push(payload);
    if (/[?&]debug=1/.test(location.search)) console.info('[track]', payload);
  }
  window.SW = window.SW || {};
  window.SW.track = track;
  window.SW.sessionId = sid;

  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-track]');
    if (!el) return;
    track(el.getAttribute('data-track'), {
      source: el.getAttribute('data-source') || undefined,
      product: el.getAttribute('data-shop-link') || el.getAttribute('data-product') || undefined,
      href: el.getAttribute('href') || undefined
    });
  });
})();
